/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPage
 *
 * Page component for AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPage
 * Path: /ar/blog/digital-sovereignty-almadar-proposal
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView as __AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalARPostAnalyticsView as __AlmadarPostDigitalSovereigntyAlmadarProposalARPostAnalyticsView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalARPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPageProps {
  // Add any page-level props here
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPage(_props: AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostDigitalSovereigntyAlmadarProposalARPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostDigitalSovereigntyAlmadarProposalARPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalARAlmadarPostDigitalSovereigntyAlmadarProposalARPage;
